import { ChevronRight } from '@drift-labs/icons';
import Switch from 'src/components/primitives/Switch/Switch';

interface NotificationSettingsRowProps {
	label: string;
	checked?: boolean;
	onCheckedChange?: (checked: boolean) => void;
	navigable?: boolean;
	onNavigate?: () => void;
}

export default function NotificationSettingsRow({
	label,
	checked,
	onCheckedChange,
	navigable,
	onNavigate,
}: NotificationSettingsRowProps) {
	if (navigable) {
		return (
			<button className="flex w-full items-center gap-lg" onClick={onNavigate}>
				<span className="flex-1 text-left typo-b4 text-text-secondary">
					{label}
				</span>
				<ChevronRight size={18} />
			</button>
		);
	}

	return (
		<div className="flex w-full items-center gap-lg">
			<span className="flex-1 typo-b4 text-text-secondary">{label}</span>
			<Switch size="sm" checked={checked} onCheckedChange={onCheckedChange} />
		</div>
	);
}
